export class ScpCrossingWmsEntity{

    id:number;
    serial:string;
    pallet:string;

    constructor (){}
}